import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/Search",
    params
  );
};

const searchUser = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/SearchUser",
    params
  );
};

const getUserRole = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/GetUserRole",
    params
  );
};

const getUserRoleByDepartmentId = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/GetUserRoleByDepartmentId",
    params
  );
};

const getSecretary = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/GetSecretary",
    params
  );
};

const postUpdate = (userDepartmentRoleId, area, province, district, subDistrict) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/DepartmentRole/Update",
      {
        userDepartmentRoleId,
        area,
        province,
        district,
        subDistrict
      }
  );
};

const postSecretaryUpdate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/DepartmentRole/SecretaryUpdate",
    params
  );
};

const postSecretaryDelete = (userDepartmentRoleId, userId) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + 
    "api/DepartmentRole/SecretaryDelete?userDepartmentRoleId=" + 
    userDepartmentRoleId + 
    "&userId=" +
    userId
  ); 
};

const addItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/DepartmentRole/Add?userId=" +
      userData.userId(),
    params
  );
};

const deleteItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/DepartmentRole/Delete?userId=" +
      userData.userId(),
    params
  );
};

export { 
  search, 
  searchUser, 
  getUserRole, 
  getUserRoleByDepartmentId, 
  addItem, 
  deleteItem, 
  postUpdate,
  getSecretary,
  postSecretaryUpdate,
  postSecretaryDelete,
};
